import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-delete-report',
  templateUrl: './delete-report.component.html',
  styleUrls: ['./delete-report.component.scss']
})

export class DeleteReportComponent {
  constructor(private modalController: ModalController) {
  }

  dismiss(value:string) {
    this.modalController.dismiss(value);
  }
}
